import { render, staticRenderFns } from "./member-content.vue?vue&type=template&id=27b75f35&scoped=true"
import script from "./member-content.vue?vue&type=script&lang=js"
export * from "./member-content.vue?vue&type=script&lang=js"
import style0 from "./member-content.vue?vue&type=style&index=0&id=27b75f35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b75f35",
  null
  
)

export default component.exports